module.exports = __webpack_public_path__ + "static/img/school-4.b9192ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-4.png
// module id = Rdrj
// module chunks = 1